import type { Time } from "@suse-o11y/date-time/time";
import { isTime } from "@suse-o11y/date-time/time";
import { isArray } from "@suse-o11y/is-array";
import { isPresent } from "@suse-o11y/is-present";
import type { NonEmptyArray } from "@suse-o11y/non-empty-array";
import { toArray } from "@suse-o11y/to-array";

function flatItem(
	item: undefined | Time | ReadonlyArray<Time> | IterableIterator<Time>,
): undefined | Time | ReadonlyArray<Time> {
	if (!isPresent(item) || isTime(item) || isArray(item)) {
		return item;
	}

	return toArray(item);
}

export function min<TValue extends Time>(
	first: TValue,
	...rest: NonEmptyArray<
		undefined | null | TValue | ReadonlyArray<undefined | null | TValue> | IterableIterator<undefined | null | TValue>
	>
): TValue;
export function min(
	first: Time,
	...rest: NonEmptyArray<
		undefined | null | Time | ReadonlyArray<undefined | null | Time> | IterableIterator<undefined | null | Time>
	>
): Time;

export function min<TValue extends Time>(
	first: NonEmptyArray<TValue>,
	...rest: ReadonlyArray<
		undefined | null | TValue | ReadonlyArray<undefined | null | TValue> | IterableIterator<undefined | null | TValue>
	>
): TValue;
export function min(
	first: NonEmptyArray<Time>,
	...rest: ReadonlyArray<
		undefined | null | Time | ReadonlyArray<undefined | null | Time> | IterableIterator<undefined | null | Time>
	>
): Time;

export function min<TValue extends Time>(
	...rest: NonEmptyArray<
		undefined | null | ReadonlyArray<undefined | null | TValue> | IterableIterator<undefined | null | TValue>
	>
): undefined | TValue;
export function min(
	...rest: NonEmptyArray<
		undefined | null | ReadonlyArray<undefined | null | Time> | IterableIterator<undefined | null | Time>
	>
): undefined | Time;

export function min(
	...args: ReadonlyArray<
		undefined | null | Time | ReadonlyArray<undefined | null | Time> | IterableIterator<undefined | null | Time>
	>
): undefined | Time {
	const items = args.flatMap(flatItem).filter(isPresent);

	if (items.length === 0) {
		return undefined;
	}

	return items.reduce((acc, value) => (value < acc ? value : acc));
}
